import { render, staticRenderFns } from "./ScreensFormComponent.vue?vue&type=template&id=56be2e82&scoped=true&"
import script from "./ScreensFormComponent.vue?vue&type=script&lang=js&"
export * from "./ScreensFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScreensFormComponent.vue?vue&type=style&index=0&id=56be2e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be2e82",
  null
  
)

export default component.exports